import { forwardRef } from "react";
import { useMediaLazyLoad } from "@/shared";
import { useCarouselCtx } from "../../ctx";
import type { ICarouselItemBgImageData } from "../../types";
import { CarouselBgImage } from "./carousel-bg-image";

export const CarouselBgImages = forwardRef<HTMLDivElement>((_, ref) => {
  const { sets } = useCarouselCtx();
  const { isVisible, setObserverRef } = useMediaLazyLoad();
  return (
    <div
      className="swiper tw-pointer-events-none tw-absolute tw-left-0 tw-top-0 -tw-z-10 tw-size-full"
      ref={(r) => {
        // Handle both function refs and object refs
        if (ref) {
          if (typeof ref === "function") ref(r);
          else ref.current = r;
        }
        setObserverRef(r);
      }}
    >
      <div className="swiper-wrapper">
        {sets.map((set) => (
          <CarouselBgImage
            key={set.id}
            data={set.settings as ICarouselItemBgImageData}
            isVisible={isVisible}
          />
        ))}
      </div>
    </div>
  );
});
